import { MonitorOutlined } from '@ant-design/icons';
import { Card, Empty, Tabs } from 'antd';
import React, { useState } from 'react';

import { EmergencyScenarioAccessPointMonitoring } from './EmergencyScenarioAccessPointMonitoring';
import { EmergencyScenarioHubMonitoring } from './EmergencyScenarioHubMonitoring';
import { EmergencyScenarioProgressMonitoring } from './EmergencyScenarioProgressMonitoring';
import type { IEmergencyScenarioMonitoringProps } from './typings';

export const EmergencyScenarioMonitoring: React.FC<IEmergencyScenarioMonitoringProps> = (props) => {
  const { emergencyScenarioMonitoring } = props;
  const { monitoredAccessPoints, monitoredHubs } = emergencyScenarioMonitoring;

  const [activeTab, setActiveTab] = useState<string>('ACCESS_POINTS');

  return (
    <Card
      title={(
        <>
          <MonitorOutlined style={{ marginRight: 8 }} />
          Emergency Scenario Monitoring
        </>
      )}
      bordered={false}
      style={{ marginBottom: 20 }}
    >
      {!monitoredAccessPoints.length && (
        <Empty description='There are no access points to monitor for this emergency scenario' />
      )}
      {!!monitoredAccessPoints.length && (
        <>
          <EmergencyScenarioProgressMonitoring
            emergencyScenarioMonitoring={emergencyScenarioMonitoring}
            activeTab={activeTab}
          />
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            animated={false}
          >
            <Tabs.TabPane
              key='ACCESS_POINTS'
              tab={`Access Points (${monitoredAccessPoints.length})`}
            >
              <EmergencyScenarioAccessPointMonitoring
                emergencyScenarioMonitoring={emergencyScenarioMonitoring}
              />
            </Tabs.TabPane>
            <Tabs.TabPane
              key='HUBS'
              tab={`Hubs (${monitoredHubs.length})`}
            >
              <EmergencyScenarioHubMonitoring
                emergencyScenarioMonitoring={emergencyScenarioMonitoring}
              />
            </Tabs.TabPane>
          </Tabs>
        </>
      )}
    </Card>
  );
};
